import React from 'react';
import { AvatarCardSmall } from '../../components/avatar-card'


export function SidebarTitle() {
    return <AvatarCardSmall />
}
